import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Show } from "@clerk/react";
import { Toaster } from "./components/ui/sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import TwoFAGate from "./components/TwoFAGate";
import Layout from "./components/Layout";
import AuthPage from "./pages/AuthPage";
import Dashboard from "./pages/Dashboard";
import Deposits from "./pages/Deposits";
import Payouts from "./pages/Payouts";
import ApiKeys from "./pages/ApiKeys";
import Security from "./pages/Security";
import Docs from "./pages/Docs";
import PaymentResult from "./pages/PaymentResult";

const Protected = () => (
  <>
    <Show when="signed-in">
      <TwoFAGate>
        {(me) => (
          <Routes>
            <Route element={<Layout me={me} />}>
              <Route index element={<Dashboard />} />
              <Route path="recebimentos" element={<Deposits />} />
              <Route path="saques" element={<Payouts />} />
              <Route path="api" element={<ApiKeys />} />
              <Route path="seguranca" element={<Security />} />
              <Route path="docs" element={<Docs />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        )}
      </TwoFAGate>
    </Show>
    <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
  </>
);

function App() {
  return (
    <div className="App dark">
      <BrowserRouter>
        <ClerkAuthProvider>
          <Routes>
            <Route path="/sign-in/*" element={<AuthPage mode="sign-in" />} />
            <Route path="/sign-up/*" element={<AuthPage mode="sign-up" />} />
            <Route path="/pagamento/sucesso" element={<PaymentResult />} />
            <Route path="/pagamento/cancelado" element={<PaymentResult cancelled />} />
            <Route path="/*" element={<Protected />} />
          </Routes>
        </ClerkAuthProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" richColors />
    </div>
  );
}

export default App;
